import { matchesSelector } from './functions.min.js';

/**
 * Post data to Freshworks when the global contact form step changes
 */
document.addEventListener(
	'stepchanged',
	async (event) => {
		if (0 === event.detail.currentIndex) return;

		//
		const targetEl = event.target;
		const selector = 'form.global-contact';
		if (!matchesSelector(targetEl, selector)) return;

		//
		const formEl = targetEl.closest(selector);
		const metaButtonEls = [...formEl.querySelectorAll('.global-contact__step-meta button')];
		const url = new URL(window.ajaxurl);

		//
		const formData = new FormData(formEl);
		formData.set('action', 'freshworks_data');
		formData.set('currentStep', event.detail.currentStep);
		formData.set('totalSteps', event.detail.totalSteps);

		// Disabled meta buttons
//		metaButtonEls.forEach(metaButtonEl => metaButtonEl.setAttribute('disabled', 'disabled'));

		//
		const options = {
			body: formData,
			method: 'POST',
		};

		// Fetch and parse the submission response
		const response = await fetch(url.toString(), options);
		const responseData = await response.json();

		// Enable meta buttons
		metaButtonEls.forEach(metaButtonEl => metaButtonEl.removeAttribute('disabled'));

		// If debug mode....
		if ('1' === formEl.dataset.debugMode) {
			// Popuplate the primary partner
			const primaryPartnerValueEl = formEl.querySelector('.global-contact__primary-partner-value');
			if (
				primaryPartnerValueEl instanceof HTMLElement &&
				undefined !== responseData.post_data?.fw_primary_partner.partner_id
			) {
				const partnerTitle = responseData.post_data.fw_primary_partner.title
				const partnerId = responseData.post_data?.fw_primary_partner.partner_id
				primaryPartnerValueEl.textContent = `${partnerTitle} (${partnerId})`;
			}

			// Populate the list of product partners
			const productPartnersListEl = formEl.querySelector('.global-contact__product-partners-list');
			if (
				productPartnersListEl instanceof HTMLElement &&
				Array.isArray(responseData.post_data.fw_product_partners) &&
				0 < responseData.post_data.fw_product_partners.length
			) {
				// Construct the list items
				const fragment = document.createDocumentFragment();
				responseData.post_data.fw_product_partners.forEach(partner => {
					const listItemEl = document.createElement('li');
					listItemEl.textContent = `${partner.title} (${partner.partner_id})`;
					fragment.append(listItemEl);
				});

				// Repopulate the list
				productPartnersListEl.innerHTML = '';
				productPartnersListEl.append(fragment);
			}
		}
	}
);

/**
 * Auto-scroll down to the partner finder results on the Eire version 
 */
(() => {
	// Find the block
	const sectionEl = document.querySelector('.elementary-partner-finder-2025');
	if (!(sectionEl instanceof HTMLElement)) return;

	// Check the country
	const country = String(sectionEl.dataset.country ?? '');
	if ('eire' !== country) return;

	// Scroll to the block
	sectionEl.scrollIntoView({
		behavior: 'smooth',
		block: 'start',
		inline: 'start',
	});
})();

/**
 * Update the completion message when the global contact form step changes
 */
document.addEventListener(
	'stepchanged',
	event => {
		//
		const targetEl = event.target;
		const selector = 'form.global-contact';
		if (!matchesSelector(targetEl, selector)) return;

		//
		const formEl = targetEl.closest(selector);
		const displayName = String(formEl?.querySelector('input[name="display_name"]')?.value ?? '');

		//
		const placeholderEl = formEl?.querySelector('[data-live-text="display_name"]');
		if (placeholderEl instanceof HTMLElement) {
			placeholderEl.innerText = displayName;
		}
	}
);

/**
 * User choosing a file to upload on the global contact form
 */
document.addEventListener(
	'change',
	event => {
		const inputSelector = '.global-contact input[name="plans_document"]';
		const labelSelector = '.plans-document__label';

		// Check event target
		const targetEl = event.target;
		if (!matchesSelector(targetEl, inputSelector)) return;

		//
		const inputEl = targetEl.closest(inputSelector);
		const formEl = inputEl.closest('form');

		const labelEl = formEl.querySelector(labelSelector);
		if (0 < inputEl.files.length) {
			labelEl.innerText = inputEl.files[0].name;
		} else {
			labelEl.innerText = String(labelEl.dataset.defaultText);
		}
	}
);

/**
 * Dynamically setup of the global contact form
 * (swap the logo and title, update the assign partner field, set IDs)
 */
document.addEventListener(
	'click',
	event => {
		const modalId = 'modal-global-contact';

		// Check event target
		const targetEl = event.target;
		const selector = `[data-action="open-modal"][data-modal-id="${modalId}"]`;
		if (!matchesSelector(targetEl, selector)) return;

		// Find elements
		const buttonEl = targetEl.closest(selector);
		const modalEl = document.getElementById(modalId);
		if (
			!(buttonEl instanceof HTMLElement) ||
			!(modalEl instanceof HTMLElement)
		) return;

		//
		const modalTitleEl = modalEl.querySelector('.modal-global-contact__title');
		const modalLogoEl = modalEl.querySelector('.modal-global-contact__thumbnail img');
		const partnerIdEl = modalEl.querySelector('input[name="partner_id"]');
		const assignInitialPartnerEl = modalEl.querySelector('input[name="assign_initial_partner"]');
		const modalPartnerEl = modalEl.querySelector('.js-partner-text');
		const formEl = modalEl.querySelector('form');
		if (
			!(modalTitleEl instanceof HTMLElement) ||
			!(modalLogoEl instanceof HTMLElement) ||
			!(partnerIdEl instanceof HTMLElement) ||
			!(modalPartnerEl instanceof HTMLElement) ||
			!(formEl instanceof HTMLElement)
		) return;
		
		//
		const submissionIdEl = formEl.querySelector('[name="submission_id"]');
		if (submissionIdEl instanceof HTMLInputElement) submissionIdEl.value = String((new Date).getTime());

		// 
		const showShareDataOptions = '1' === String(buttonEl?.dataset?.showDataShareOptions);
		const dataShareFullInputEls = [...formEl.querySelectorAll('.global-contact__field[data-type="partners-opt-in"][data-share-options="full"] input')];
		const dataShareMinimalInputEls = [...formEl.querySelectorAll('.global-contact__field[data-type="partners-opt-in"][data-share-options="minimal"] input')];
		formEl.dataset.showShareDataOptions = (true === showShareDataOptions) ? '1' : '0';
		if (true === showShareDataOptions) {
			dataShareFullInputEls.forEach(el => el.removeAttribute('disabled'));
			dataShareMinimalInputEls.forEach(el => el.setAttribute('disabled', 'disabled'));
			if (0 < dataShareFullInputEls.length) dataShareFullInputEls.at(0).checked = true;
		} else {
			dataShareFullInputEls.forEach(el => el.setAttribute('disabled', 'disabled'));
			dataShareMinimalInputEls.forEach(el => el.removeAttribute('disabled'));
			if (0 < dataShareMinimalInputEls.length) dataShareMinimalInputEls.at(0).checked = true;
		}

		// Store defaults
		if (!modalTitleEl.dataset.defaultTitle) modalTitleEl.dataset.defaultTitle = modalTitleEl.innerText;
		if (!modalLogoEl.dataset.defaultLogo) modalLogoEl.dataset.defaultLogo = modalLogoEl.getAttribute('src');
		if (!modalPartnerEl.dataset.defaultPartner) modalPartnerEl.dataset.defaultPartner = modalPartnerEl.innerText;

		// Pick a title
		if (buttonEl.dataset.globalContactTitle) {
			const newTitle = String(buttonEl.dataset.globalContactTitle);
			modalTitleEl.innerText = newTitle;
			modalPartnerEl.innerText = newTitle;
		} else {
			modalTitleEl.innerText = modalTitleEl.dataset.defaultTitle || '';
			modalPartnerEl.innerText = modalTitleEl.dataset.defaultTitle || 'our partners';
		}

		// Set "assign initial partner" field
		if (
			assignInitialPartnerEl instanceof HTMLInputElement &&
			buttonEl.dataset.assignInitialPartner
		) {
			const assignInitialPartner = ('1' === buttonEl.dataset.assignInitialPartner) ? 1 : 0;
			assignInitialPartnerEl.value = String(assignInitialPartner);
		}

		// Pick a logo
		if (buttonEl.dataset.globalContactLogo) {
			modalLogoEl.setAttribute('src', String(buttonEl.dataset.globalContactLogo));
		} else if (modalLogoEl.dataset.defaultLogo) {
			modalLogoEl.setAttribute('src', String(modalLogoEl.dataset.defaultLogo));
		}

		// Assign the Schuco partner ID to the form if it exists
		if (partnerIdEl instanceof HTMLElement && buttonEl.dataset.globalContactPartnerId) {
			partnerIdEl.value = parseInt(buttonEl.dataset.globalContactPartnerId ?? 0, 10);
		}

		// Goto step 1
		modalEl.querySelector('[is="elementary-stepped-form"]')?.gotoStep(0, false);
	}
);

/**
 * Track step changes on the global contact form in GA
 */
document.addEventListener(
	'stepchanged',
	async (event) => {
		// Ensure we're looking at the global contact form
		const targetEl = event.target;
		const selector = 'form.global-contact';
		if (!matchesSelector(targetEl, selector)) return;

		// Parse values
		const currentStep = Number(event.detail.currentStep ?? 0);
		const previousStep = Number(event.detail.previousStep ?? 0);

		// Ignore if the step didn't change (happens when the modal is first opened)
		if (currentStep === previousStep) return;

		// Define the data
		const data = {
			step: currentStep,
			previous_step: previousStep,
		};

		// Track the event
		if ('function' === typeof gtag) {
			gtag('event', 'contact_form_step_changed', data);
		} else {
			console.warn(`gtag is not defined. "contact_form_step_changed" not sent:`, JSON.stringify(data));
		}
	}
)

/**
 * Track when the global contact modal opens
 */
document.addEventListener(
	'modalopened',
	event => {
		// Ignore if not the global contact form
		if ('modal-global-contact' !== event.detail.id) return;

		// Define the data
		const data = {};

		// Track the event
		if ('function' === typeof gtag) {
			gtag('event', 'contact_form_modal_opened', data);
		} else {
			console.warn(`gtag is not defined. "contact_form_modal_opened" not sent:`, JSON.stringify(data));
		}
	}
);

/**
 * Track when the global contact modal closes
 */
document.addEventListener(
	'modalclosed',
	event => {
		// Ignore if not the global contact form
		if ('modal-global-contact' !== event.detail.id) return;

		// Define the data
		const data = {};

		// Track the event
		if ('function' === typeof gtag) {
			gtag('event', 'contact_form_modal_closed', data);
		} else {
			console.warn(`gtag is not defined. "contact_form_modal_closed" not sent:`, JSON.stringify(data));
		}
	}
);